import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    InputAdornment,
    TextField,
} from '@mui/material';
import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';
import * as React from 'react';
import { AddStaffInfoRequest } from 'types/add-staff-user/add-staff-info';
import rgba from 'assets/theme/function/rgba';
import DialogIconClose from 'component/dialog-icon-close';
import { ReactComponent as Eye } from 'assets/images/sign-in/eye.svg';
import { ReactComponent as NounEye } from 'assets/images/sign-in/noun-eye.svg';
import { useState } from 'react';

interface Props {
    closeModal: () => void;
    staffInfo: AddStaffInfoRequest;
    setStaffInfo: React.Dispatch<React.SetStateAction<AddStaffInfoRequest>>;
    handleAddStaffClick: () => void;
}

const AddStaff: React.FC<Props> = (props: Props) => {
    const { closeModal, staffInfo, setStaffInfo, handleAddStaffClick } = props;

    const [showPass, setShowPass] = useState<boolean>(false);

    return (
        <>
            <Box
                display={'flex'}
                justifyContent={'center'}
                bgcolor={rgba(colors.primary.main, 0.1)}
            >
                <DialogTitle textTransform={'uppercase'}>
                    ADD NEW STAFF
                </DialogTitle>
                <DialogIconClose handleClose={closeModal} />
            </Box>

            <DialogContent>
                <Box display={'flex'}>
                    <TextField
                        fullWidth
                        label={'Email'}
                        name={'email'}
                        value={staffInfo.email ? staffInfo.email : ''}
                        onChange={(e) => {
                            const { name, value } = e.target;
                            setStaffInfo((prevState) => ({
                                ...prevState,
                                [name]: value,
                            }));
                        }}
                    />
                    <TextField
                        sx={{ ml: pxToRem(5) }}
                        fullWidth
                        label={'Last Name'}
                        name={'lastName'}
                        value={staffInfo.lastName ? staffInfo.lastName : ''}
                        onChange={(e) => {
                            const { name, value } = e.target;
                            setStaffInfo((prevState) => ({
                                ...prevState,
                                [name]: value,
                            }));
                        }}
                    />
                </Box>
                <Box mt={pxToRem(10)} display={'flex'}>
                    <TextField
                        fullWidth
                        label={'First Name'}
                        name={'firstName'}
                        value={staffInfo.firstName ? staffInfo.firstName : ''}
                        onChange={(e) => {
                            const { name, value } = e.target;
                            setStaffInfo((prevState) => ({
                                ...prevState,
                                [name]: value,
                            }));
                        }}
                    />
                    <TextField
                        sx={{ ml: pxToRem(5) }}
                        fullWidth
                        label={'Password'}
                        name={'password'}
                        value={staffInfo.password ? staffInfo.password : ''}
                        onChange={(e) => {
                            const { name, value } = e.target;
                            setStaffInfo((prevState) => ({
                                ...prevState,
                                [name]: value,
                            }));
                        }}
                        type={showPass ? 'text' : 'password'}
                        slotProps={{
                            input: {
                                'aria-label': 'password',
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() =>
                                                setShowPass(
                                                    (current) => !current,
                                                )
                                            }
                                            onMouseDown={(e) =>
                                                e.preventDefault()
                                            }
                                            edge="end"
                                        >
                                            {showPass ? <Eye /> : <NounEye />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    fullWidth
                    onClick={handleAddStaffClick}
                    variant={'contained'}
                >
                    Add Staff
                </Button>
            </DialogActions>
        </>
    );
};
export default AddStaff;
